import { generateNonWorkingHoursBlock } from './calculateSingleNonWorkingHourBlocks';

/**
 * Wrapper function to calculate non working hour blocks
 * This takes care of mulitple non working hour blocks for a column
 * @param workDaysWiseHoursStartTimeInMinutes - start time blocks in minutes
 * @param workDaysWiseHoursEndTimeInMinutes - end time blocks in minutes
 * @param date - current date or column date
 * @param isPast - (boolean) is date in past
 * @param workDays - working days in view
 * @param dayStartMinute - time the day starts
 * @param dayLength - complete day in minutes - eg: 1440
 * @param dayOfWeek - number of day in week [1-7]
 */
export const generateNonWorkingTimes = (
    workDaysWiseHoursStartTimeInMinutes,
    workDaysWiseHoursEndTimeInMinutes,
    date,
    isPast,
    workDays,
    dayStartMinute,
    dayLength,
    dayOfWeek
) => {
    let nonWorkingTimes: { start: number; end: number }[] = [];
    for (let i = 0; i < workDaysWiseHoursStartTimeInMinutes[dayOfWeek]?.length; i++) {
        let subNonWorkingTimes = generateNonWorkingHoursBlock(
            workDaysWiseHoursStartTimeInMinutes[dayOfWeek][i],
            workDaysWiseHoursEndTimeInMinutes[dayOfWeek][i],
            date,
            isPast,
            workDays,
            dayStartMinute,
            dayLength,
            false
        );
        nonWorkingTimes.push(...subNonWorkingTimes);
    }

    // if no working hours provuded the whole day is non working
    if (nonWorkingTimes.length == 0) {
        nonWorkingTimes.push({ start: 0, end: dayLength });
    }

    return combineOverlappingNonWorkingHours(nonWorkingTimes);
};

/**
 * @param nonWorkingTimes - the list of all non working hours calibrated either with start of day or end of day
 * this leads to overlaping hours, below logic will separate these hours into defined blocks
 * this function separates out overlapping hours and combines to form individual non working hour blocks
 */
export const combineOverlappingNonWorkingHours = (
    nonWorkingTimes: { start: number; end: number }[]
) => {
    let combinedNonWorkingTimes: { start: number; end: number }[] = [];

    // first block will always be wrt start of day
    const startOfNonWorkingTime = nonWorkingTimes[0];
    combinedNonWorkingTimes.push(startOfNonWorkingTime);

    if (nonWorkingTimes.length > 1) {
        // last block will always be wrt end of day
        const endOfWorkingTime = nonWorkingTimes.slice(-1)[0];

        for (let i = 1; i < nonWorkingTimes.length - 1; i = i + 2) {
            combinedNonWorkingTimes.push({
                start: nonWorkingTimes[i].start,
                end: nonWorkingTimes[i + 1].end,
            });
        }
        combinedNonWorkingTimes.push(endOfWorkingTime);
    }

    return combinedNonWorkingTimes;
};
